import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUTCTimeZoneOffset, timeZone } from '@brighterion/utils/date-timezone';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';

import styles from './LocaleInfo.css';

const LocaleInfo = () => {
    const { currencyCode } = useTemplateStore.getState().template;
    const { t } = useTranslation();
    const timeZoneText = `${timeZone?.replace(/_/g, ' ') ?? ''} (UTC${getUTCTimeZoneOffset()})`;

    return (
        <div className={styles.localeContainer}>
            <span className={styles.localeItem}>
                {t('Currency')}: <span className={styles.localeItemValue}>{currencyCode}</span>
            </span>
            <span className={styles.localeItem}>
                {t('Timezone')}: <span className={styles.localeItemValue}>{timeZoneText}</span>
            </span>
        </div>
    );
};

export default LocaleInfo;
